module.exports = __webpack_public_path__ + "img/Wolt_600x150.1d427aa1.jpg";